<template>
  <div class="head">
    <div class="title">
      {{title}}
    </div>
    <div v-if="isUser">
      <app-btn
        @click="edit()"
      >
        {{$ml.get(`edit`)}}
      </app-btn>
      <app-btn
        styling="outline"
        @click="deleteFert()"
      >
        {{$ml.get(`delete`)}}
      </app-btn>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    isUser: Boolean,
  },
  methods: {
    edit () {
      this.$store.dispatch('fertilizers/popup/open', {open: true, isNew: false});
    },
    deleteFert () {
      this.$store.commit('modals/prompt/open', {
        onAccept: () => {
          this.$store.dispatch('fertilizers/deleteFertilizer').then(res => {
            if (res.data.success == true) {
              this.$notify({
                group: 'notices',
                title: `Fertilizer successfully deleted!`,
                type : 'Success',
              });

              this.$router.push('/dashboard/fertilizers/' + this.$store.getters['fertilizers/getType']);
            }
          });
        },
        text: 'Are you sure want to remove this fertilizer?',
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .head {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    width: 100%;
    
    .title {
      color: #333333;
      font-size: 26px;
      line-height: 100%;
      font-weight: bold;
    }

    >div:last-child {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      >button {
        margin: 0 10px;
      }
    }
  }
</style>
